import React from "react";
import { Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
} from "chart.js";
import { DASHBOARD_PALETTE } from "../../utils/palette.token";
import { ITokenChart } from "./type";

ChartJS.register(ArcElement, Tooltip);

const options = {
  responsive: true,
  maintainAspectRatio: false,
  cutout: "70%",
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      backgroundColor: DASHBOARD_PALETTE.surfaceElevated,
      titleColor: DASHBOARD_PALETTE.textPrimary,
      bodyColor: DASHBOARD_PALETTE.textSecondary,
      borderColor: DASHBOARD_PALETTE.borderAccent,
      borderWidth: 1,
      padding: 12,
      cornerRadius: 8,
      displayColors: true,
      boxPadding: 6,
    },
  },
  elements: {
    arc: {
      borderWidth: 0,
    },
  },
};

const TokenChart = ({ data }: ITokenChart) => {
  const dataChart = {
    labels: data?.map(
      (item: any) => item?.lables ?? item?.labels ?? ""
    ),
    datasets: [
      {
        data: data?.map((item: any) => item?.data),
        backgroundColor: data?.map((item: any) => item?.color),
        borderColor: DASHBOARD_PALETTE.surface,
        borderWidth: 3,
        hoverOffset: 8,
      },
    ],
  };

  return <Doughnut data={dataChart} options={options} />;
};

export default TokenChart;
